module.exports = __webpack_public_path__ + "static/media/fi-sr-layers.7afd35bd.svg";